import { render } from "./VDOL_EmployVT_Claimant.vue?vue&type=template&id=7caab8f7"
import script from "./VDOL_EmployVT_Claimant.vue?vue&type=script&lang=js"
export * from "./VDOL_EmployVT_Claimant.vue?vue&type=script&lang=js"

import "./VDOL_EmployVT_Claimant.vue?vue&type=style&index=0&id=7caab8f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__